export default {
  pns: 'PENSOSBUD - Surat Permohonan Surat Akhir Studi Bagi PNS',
  graduate: 'PENSOSBUD - Keterangan Lulus Sekolah/Universitas',
  transferSchool: 'PENSOSBUD - Surat Pindah Sekolah'
};
